// 칩 선택 — 스펙 입력 대신 "눌러서 고르는" 입력 (multi: 여러 개, 아니면 하나)
interface Props {
  options: string[];
  value: string[];
  onChange: (next: string[]) => void;
  max?: number;
  multi?: boolean;
}

export default function ChipGroup({ options, value, onChange, max, multi = true }: Props) {
  const toggle = (opt: string) => {
    if (!multi) return onChange(value.includes(opt) ? [] : [opt]);
    if (value.includes(opt)) return onChange(value.filter((v) => v !== opt));
    if (max && value.length >= max) return;
    onChange([...value, opt]);
  };
  return (
    <div className="pc-chips">
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          className={`mm-chip pc-chip${value.includes(opt) ? ' on' : ''}`}
          onClick={() => toggle(opt)}
          aria-pressed={value.includes(opt)}
        >
          {opt}
        </button>
      ))}
      {max && multi ? <span className="pc-chips__count">{value.length}/{max}</span> : null}
    </div>
  );
}
